import React from 'react';
import {connect} from 'react-redux';
import {BannerItem} from './BannerItem';

function mapStateToProps(state) {
    return {
        banner: state.config.context.bodyConfig.banner
    };
}

export const BannerComponent = ({banner}) => (
    <ul className="banner">
        {banner.map((type) => (
            <li key={type}>
                <BannerItem type={type} />
            </li>
        ))}
    </ul>
);


export const Banner = connect(mapStateToProps)(BannerComponent);
